const emptyValue = 'qualsiasi';

export default function sliderFactory(noUiSlider) {
    return class Slider {
        constructor(element) {
            this.$element = $(element);
            this.min = this.$element.data('min');
            this.max = this.$element.data('max');
            this.minValue = this.$element.data('minValue') || this.min;
            this.maxValue = this.$element.data('maxValue') || this.max;
            this.step = this.$element.data('step') || 1;
            this.label = this.$element.data('label') || '';
            this.minInput = this.$element.siblings('#' + this.$element.prop('id') + '_min');
            this.maxInput = this.$element.siblings('#' + this.$element.prop('id') + '_max');
            this.single = this.$element.data('single') !== undefined;
            this.noEmpty = this.$element.data('noEmpty') !== undefined;
            this.isPower = this.$element.data('isPower');
        }

        getValue(value, defaultValue) {
            if (this.single) {
                return value;
            }

            return value === defaultValue ? emptyValue : value;
        }

        enable() {
            this.$element.parent().show();
            this.minValue = this.minInput.val() || this.minValue;
            let value = this.minValue === this.min ? this.maxValue : this.minValue;
            this.setLabels();
            this.minInput.val(value);
            this.slider.set([value]);
        }

        disable() {
            this.$element.parent().hide();
            this.minInput.val('');
            this.maxInput.val('');
        }


        setLabels() {
            let values = this.slider.get() || [0, 0];
            let min = this.single ? parseInt(values, 10) : parseInt(values[0], 10);
            let max = this.single ? parseInt(values, 10) : parseInt(values[1], 10);
            let minLabel = emptyValue;

            if (min > this.min || this.noEmpty) {
                this.minInput.val(min).trigger('change');
                minLabel = min +' '+ this.label;
                if (this.isPower){
                    //calculate new label
                    minLabel+=' '+ '('+ this.calculateCV(min) + ' '+ 'CV)';
                }
            } else {
                this.minInput.val('').trigger('change');
            }

            let maxLabel = emptyValue;

            if (max < this.max || this.noEmpty) {
                this.maxInput.val(max).trigger('change');
                maxLabel = max +' '+ this.label;
                if (this.isPower) {
                    //calculate new label
                    maxLabel+= ' ' + '(' + this.calculateCV(max) + ' '+ 'CV)';
                }
            } else {
                this.maxInput.val('').trigger('change');
            }

            $(`[data-from=${this.$element.prop('id')}]`).text(minLabel);
            $(`[data-to=${this.$element.prop('id')}]`).text(maxLabel);
        }

        calculateCV(kw) {
            const value = kw * 1.35962;
            return parseInt(value);
        }

        init() {
            let el = document.getElementById(this.$element.prop('id'));
            let options = {
                start: [this.minValue],
                step: this.step,
                range: {
                    min: this.min,
                    max: this.max
                }
            };

            if (!this.single) {
                options.start = [this.minValue, this.maxValue];
            }

            this.slider = noUiSlider.create(el, options);
            this.slider.on('update', () => this.setLabels()) ;
            this.setLabels();

            this.$element
                .off('element:enable', '', $.proxy(this, 'enable'))
                .on('element:enable', $.proxy(this, 'enable'));

            this.$element
                .off('element:disable', '', $.proxy(this, 'disable'))
                .on('element:disable', $.proxy(this, 'disable'));

            if (typeof this.$element.data('disableOn') !== 'undefined') {
                let eventName = this.$element.data('disableOn');
                $(document)
                    .off(eventName, '', $.proxy(this, 'disable'))
                    .on(eventName, $.proxy(this, 'disable'));
            }

            if (this.$element.data('enabled')) {
                this.enable();
            }

            if(this.$element.data('disabled')) {
                this.disable();
            }
        }
    };
}
